import { css } from "styled-components";
import {
  contentFadeInAnim,
  rotateCardAnim,
  // initCardApearAnim,
  showCardContentAnim,
  cardChangeAnim,
  whiteBackgroundAnim,
  widthChangeAnim,
  cardClickAnim,
  cardInitApearAnim,
} from "./InteractionsKeyframes";

export const contentFadeIn = css`
  animation: ${contentFadeInAnim} 0.5s forwards;
`;
export const rotateCard = css`
  ${rotateCardAnim}
`;
export const initCardApear = css`
  animation: ${cardInitApearAnim} 0.5s forwards;
`;
export const showCardContent = css`
  ${showCardContentAnim}
`;
export const cardChange = css`
  ${cardChangeAnim}
`;
export const whiteBackground = css`
  ${whiteBackgroundAnim}
`;
export const widthChange = css`
  animation: ${widthChangeAnim} 317ms;
`;
export const cardClick = css`
  animation: ${cardClickAnim} 0.4s;
`;
